import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { NavController, Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth-service/auth-service';
import { EventsService } from '../services/eventsService';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  redirectDone = false;
  constructor(
    public platform: Platform,
    private authService: AuthService,
    public nav: NavController,
    private events: EventsService,
    public http: HttpClient) {}

  private mustRefreshTokenAndSession(urlSeg: UrlSegment[]): boolean {
    // return false;
    if (!this.authService.registryIntegration()) { // solo nei casi di integrazione con il web esse3
      return false;
    }

    const requrl = urlSeg[0].path;
    if (requrl.match('count') ||
        requrl.match('conta') ||
        requrl.match('configurazioni') ||
        requrl.match('v1\/me') ||
        requrl.match('aggiornamento')) {
      return false;
    }
    return true;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const userAuthenticated = this.authService.isAuthorized();
      const urlSeg: UrlSegment[] = next.url;

      if (this.mustRefreshTokenAndSession(urlSeg)) {
        this.authService.refreshTokenAndSession(urlSeg[0].path);
      }

      if (userAuthenticated || urlSeg.find(x => x.path === 'debug' )) {
        console.log('utente autorizzato ad accedere alla pagina', urlSeg[0].path);
        this.redirectDone = false;
        console.log('this.redirectDone', this.redirectDone);
        return true;
      } else {
        // if (this.authService.isAuthExpired()) {
        if (this.authService.getAuthToken() && this.authService.isAuthExpired()) {
          console.error('AuthExpired: utente NON autorizzato ad accedere alla pagina');
          // nei casi in cui il token scade e si è fermi in una pagina senza
          // recuperi in backgoud, la navigazione resta bloccata e
          // la rediect o la pubblicazione dell'evento di logout che funzionano correttamente
          // nell'interceptor, non vanno a buon fine
          // perché i parametri contenuti nell'env risulatano null, come se non avesse il tempo di ripopolarlo
          // Dopo un po' di tentativi ho seguito un workarounf
          // suggerito in questo post https://github.com/angular/angular/issues/16211
          // non è il massimo perché non si resta all'interno della navigazione precedente e
          // non si riescono a passare i dati alla pagina iniziale per segnalare
          // la conclusione della sessione, ma si naviga correttamente e non si resta bloccati
          // La soluzione va applicata sia alla pwa che all'app
          // Fa uso di un timer per redirigere alla pagina iniziale, evidentemente
          // nel tempo atteso l'app ripopola correttamente i dati dell'env e non genera l'errore

          // ulteriore evoluzione: il problema persiste nelle situazioni in cui
          // l'app viene riavviata o dopo un resume.
          // Utilizzando il controllo che la piattaform sia ready sembra funzionare
          // correttamente
          // if (this.platform.is(PlatformName)) { // ex cordova
          this.platform.ready().then(() => {
            console.error('this.redirectDone in auth expired', this.redirectDone);
            if (!this.redirectDone) {
              setTimeout(() => {
                this.redirectDone = true;
                this.events.logout.next({authExpired: true , fromGuard: true});
                // this.events.publish('logout');
              }, 1000);
            }
            return false;
          });
          // }
        } else {
          // console.log('this.authService.getAuthToken()', this.authService.getAuthToken());
          console.log('this.authService.isAuthExpired()', this.authService.isAuthExpired());
          console.error('utente NON autorizzato ad accedere alla pagina');
        }
        return false;
      }
    return true;
  }
}
